import IonGenerationProps from "./IonGenerationProps.js";
import IonConfig from "./IonConfig.js";
import EicExtractionProps from "./EicExtractionProps.js";
import {MeasuringModeName} from "./MeasuringModeName.js";
import DetectorMode from "./DetectorMode.js";

export default class EicExtractionPropsWithDetectorType extends EicExtractionProps {
    /** @type {DetectorMode} */
    #detectorMode;

    /**
     * @param {IonGenerationProps} ionGenProps
     * @param {IonConfig[]} ionConfigs
     * @param {DetectorMode} detectorMode
     */
    constructor(ionGenProps, ionConfigs, detectorMode) {
        super(ionGenProps, ionConfigs);
        this.#detectorMode = detectorMode;
    }

    /** @returns {boolean} */
    isProductIonScan(){
        return this.#detectorMode.measuringMode === MeasuringModeName.PRODUCT_SCAN
    }

    /** @returns {IonMode} */
    get ionMode(){
        return this.#detectorMode.ionMode;
    }

    /** @returns {DetectorMode} */
    get detectorMode() {
        return this.#detectorMode;
    }

    /** @returns {string} */
    get displayName() {
        return this.measuringMode + " " + this.ionMode.uiName;
    }

    /** @returns {string} */
    get measuringMode(){
        return this.#detectorMode.measuringMode
    }

    /** @returns {EicExtractionPropsWithDetectorType} */
    copy() {
        return new EicExtractionPropsWithDetectorType(
            this.ionGenerationProps.copy(),
            this.ionConfigs.map(ic => ic.copy()),
            this.#detectorMode
        );
    }

    equals(other) {
        if (this === other) return true;
        if (other === null || !(other instanceof EicExtractionPropsWithDetectorType)) return false;
        return this.#detectorMode.equals(other.detectorMode) &&
            this.ionConfigs.length === other.ionConfigs.length &&
            this.ionConfigs.every((ic, i) => ic.equals(other.ionConfigs[i]) &&
            this.ionGenerationProps.equals(other.ionGenerationProps));
    }

    /**
     * @returns {{
     * fragments: {name: *, mf: *, structure: *, charge: *, maxCount: *, enabled: boolean}[],
     * qualifierIntensityResolution: number,
     * massResolution: number,
     * detector: {measuringMode: string, ionMode: string, analyticalMethod: string}}}
     */
    toServerJson() {
        return {
            fragments: this.ionGenerationProps.fragments.map(fr => fr.toServerJson()),
            qualifierIntensityResolution: this.ionGenerationProps.qualifierIntensityResolution,
            massResolution: this.ionGenerationProps.massResolution,
            detector: this.detectorMode.toServerJson(),
        }
    }

    /**
     * @returns {{
     * fragments: {name: *, mf: *, structure: *, charge: *, maxCount: *, enabled: boolean}[],
     * ionConfigs: {name: string, mw: number, calcInt: number, userInt: number|null, ql: boolean, qn: boolean}[],
     * qualifierIntensityResolution: number,
     * resolution: number,
     * detectorType: {measuringMode: string, ionMode: string, analyticalMethod: string}}}
     */
    toServerJsonWithIonConfig() {
        return {
            fragments: this.ionGenerationProps.fragments.map(fr => fr.toServerJson()),
            ionConfigs: this.ionConfigs.map(ic => ic.toServerJson()),
            qualifierIntensityResolution: this.ionGenerationProps.qualifierIntensityResolution,
            resolution: this.ionGenerationProps.massResolution,
            detectorType: this.detectorMode.toServerJson(),
        }
    }

    /**
     * @param j
     * @returns {EicExtractionProps}
     */
    static parseServerJson(j) {
        return new EicExtractionPropsWithDetectorType(IonGenerationProps.parseServerJson(j.ionGenerationProps),
            IonConfig.parseMany(j.ionConfigs), DetectorMode.parseJson(j.detectorType));
    }
}